import { render, staticRenderFns } from "./StatsDisplay.vue?vue&type=template&id=51788412&scoped=true"
import script from "./StatsDisplay.vue?vue&type=script&lang=js"
export * from "./StatsDisplay.vue?vue&type=script&lang=js"
import style0 from "./StatsDisplay.vue?vue&type=style&index=0&id=51788412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51788412",
  null
  
)

export default component.exports